import { render, staticRenderFns } from "./SystemProjectDemand.vue?vue&type=template&id=7d349055&"
import script from "./SystemProjectDemand.vue?vue&type=script&lang=js&"
export * from "./SystemProjectDemand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VExpansionPanel,VExpansionPanelContent,VExpansionPanelHeader,VExpansionPanels,VSwitch})


/* hot reload */
if (module.hot) {
  var api = require("/builds/saas-tool/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d349055')) {
      api.createRecord('7d349055', component.options)
    } else {
      api.reload('7d349055', component.options)
    }
    module.hot.accept("./SystemProjectDemand.vue?vue&type=template&id=7d349055&", function () {
      api.rerender('7d349055', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SystemProjectDemand.vue"
export default component.exports